import { Toaster } from "components/notification/Toaster";
import useAccountControlActions from "dataflow/billingPortal/actions/useAccountControl.actions";
import useOutletsActions from "dataflow/billingPortal/actions/useOutlet.actions";
import { isArrayNotEmpty } from "functions";
import { useCustomSelector } from "hooks";
import { useEffect, useRef, useState } from "react";


export default function useFilters() {
    const [renderDate, setRenderDate] = useState();
    const comId = useRef();
    const [outletIDs, setOutletIDs] = useState([]);
    const [isOutletListModalVisible, setIsOutletListModalVisible] = useState();
    
    const [isFiltering, setIsFiltering] = useState();
    const [isResetRequired, setIsResetRequired] = useState();

    const { getOutletSTList_requesting } = useCustomSelector("outlet");

    // Get list of company IDs
    const { getAllComList } = useAccountControlActions();
    useEffect(() => {
        getAllComList();
    }, []);

    // Reset the reset
    useEffect(() => {
        if (isResetRequired) setIsResetRequired(false);
    }, [isResetRequired]);

    // Get list of outlets
    const { getAllOutlets } = useOutletsActions();
    useEffect(() => {
        if (comId.current) getAllOutlets(null, null, null, { comId: comId.current });
    }, [comId.current]);
    
    function onFilterSubmit(setFilterOptions, filterOptions = {}, isReset) {
        if (isReset) {
            comId.current = "";
            setOutletIDs([]);
            setRenderDate("");
            setIsResetRequired(true);
        }
        else if (comId.current && renderDate) {
            setIsFiltering(true);
            setFilterOptions({
                ...filterOptions,
                comId: comId.current,
                renderDate,
                outletIDs: (isArrayNotEmpty(outletIDs))? outletIDs.map((id) => {
                    return {
                        outletID: id
                    }
                }):""
            })
        }
        else {
            Toaster({
                type: "info",
                msg: (renderDate? "COM ID": "Render Date") + " filter input required"
            })
        }
    }

    useEffect(() => {
        if (!getOutletSTList_requesting) setIsFiltering(false);
    }, [getOutletSTList_requesting])
    
    return {
        renderDate, setRenderDate,
        comId,
        outletIDs, setOutletIDs,

        isFiltering, onFilterSubmit,
        isResetRequired, setIsResetRequired,
        isOutletListModalVisible, setIsOutletListModalVisible
    }
}